import { Typography } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useSearchParamsContext,
  useSearchQueryContext,
} from 'components/search/search.hooks';
import ClientPaginationDataGrid from 'components/client-pagination-data-grid/client-pagination-data-grid.component';
import PercentDeliveredChip from 'pages/analytics/sms-reports/percent-delivered-chip/percent-delivered-chip.component';
import { useSearchParams } from 'react-router-dom';
import { GridColDef } from '@mui/x-data-grid-premium';

const GuestCheckoutVerificationDataGrid = () => {
  const { t } = useTranslation();

  const {
    searchResults,
    queryState: { isFetching },
  } = useSearchQueryContext();

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'locationName',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.grid.locationName',
        ),
        hideable: false,
        minWidth: 220,
        flex: 2,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.locationName}</Typography>,
      },
      {
        field: 'smsSent',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.grid.smsSent',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.smsSent}</Typography>,
      },
      {
        field: 'smsDelivered',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.grid.smsDelivered',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.smsDelivered}</Typography>,
      },
      {
        field: 'percentDelivered',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.grid.percentDelivered',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => (
          <PercentDeliveredChip score={row?.percentDelivered} />
        ),
      },
      {
        field: 'segmentsSent',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.grid.segmentsSent',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.segmentsSent}</Typography>,
      },
    ],
    [t],
  );

  const { searchParams: sp, setParamValue } = useSearchParamsContext();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.size) {
      setParamValue('startDate', sp.startDate.value);
      setParamValue('endDate', sp.endDate.value);
      setParamValue('storeIds', sp.storeIds.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ClientPaginationDataGrid
      columns={columns}
      rows={searchResults}
      isLoading={isFetching}
      getRowId={row => row.locationId}
      data-testid="GuestCheckoutVerification.DataGrid"
    />
  );
};

export default GuestCheckoutVerificationDataGrid;
